/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

'use client';

import { useRouter } from 'next/navigation';

interface RedirectParams {
  page: string;
  view?: string;
  workflowNames?: string | null;
}

export const useSankeyToPromptsNavigation = () => {
  const router = useRouter();

  const handlePromptClick = (
    redirect?: RedirectParams,
    selectedNodeKey?: string,
    workflowNames?: string | null
  ) => {
    const currentPath = window.location.pathname;
    const currentParams = new URLSearchParams(window.location.search);
    const isComponentsTab = currentPath.includes('/components');

    if (isComponentsTab) {
      const newPath = `${currentPath}/prompts`;

      if (
        currentParams.get('days') === 'all' ||
        currentParams.get('days') === '7'
      ) {
        currentParams.delete('start');
        currentParams.delete('end');
      }

      const newUrl = `${newPath}?${currentParams.toString()}`;
      router.push(newUrl);
    } else {
      // Extract app name from current path
      const pathParts = currentPath.split('/');
      const appName = pathParts[pathParts.length - 1];

      currentParams.delete('view_by');
      currentParams.delete('view');

      // add fact_name to URL
      if (redirect?.page) {
        currentParams.set('fact_name', redirect.page.toLowerCase());
      }
      // add breakdown_filter to URL
      if (selectedNodeKey) {
        currentParams.set('breakdown_filter', selectedNodeKey);
      }

      if (redirect?.view) {
        currentParams.set('view', redirect.view.toLowerCase());
      }
      // add workflow filter to URL
      if (workflowNames !== undefined && workflowNames !== null) {
        currentParams.set('workflow_names', workflowNames);
      }

      const newUrl = `/apps/${appName}/prompts?${currentParams.toString()}`;
      router.push(newUrl);
    }
  };

  return { handlePromptClick };
};
